import Btn from '@components/Btn';
import { HIDE_EVERYTHING_BUTTON, HOME_BUTTON_TWO_TEXT } from '@lib/constants';
import { trackUsageClick } from '@lib/helpers/reporting';
import { useRouter } from 'next/router';
import { useI18n } from '@lib/i18n';
import { useEffect } from 'react';

import { HP_ANIMATIONS, HP_ANIMATION_TYPE } from '@lib/constants';

import { staggerAnimations } from '@lib/helpers';
import { initTriggeredAnimations } from '@lib/helpers/blockAnimations';

export default function EverythingButton({ isAdvisor = false }) {
	const router = useRouter();
	const { t } = useI18n();

	const handleClick = () => {
		trackUsageClick('everything');
		router.push('/everything');
	};

	const animationClass = HP_ANIMATIONS && HP_ANIMATION_TYPE
	? `animate ${HP_ANIMATION_TYPE} hp-has-triggered-animation`
	: '';

	const animationData =
	HP_ANIMATIONS && HP_ANIMATION_TYPE
		? {
				'data-hp-trigger-selector': '',
				'data-hp-triggered-animation':
					HP_ANIMATION_TYPE,
				'data-hp-trigger-event':
					'viewport',
				'data-hp-triggered-played' : '0',
			}
		: {};

	useEffect(() => {
		staggerAnimations();
		initTriggeredAnimations();
	}, []);

	if (isAdvisor) {
		return (
			<Btn
				onClick={handleClick}
				customClass={['outline', 'mb-2', 'outline--home', 'everything', `${animationClass}`]}
				{...animationData}
			>
				{t('home.everything_button', HOME_BUTTON_TWO_TEXT)}
			</Btn>
		);
	}

	if (HIDE_EVERYTHING_BUTTON) {
		return;
	}

	return (
		<Btn
			onClick={handleClick}
			customClass={['outline', 'mb-2', 'outline--home', `${animationClass}`]}
			{...animationData}
		>
			{t('home.everything_button', HOME_BUTTON_TWO_TEXT)}
		</Btn>
	);
}
